import moment from 'moment';
import { num, round3, summary } from './allocationHelpers';

export const SETOFF = 'SETOFF';
export const isSetOff = (paymentType) => (paymentType || '').trim().toUpperCase() === SETOFF;
export const isChequeOrPdc = (paymentType) => ['CHEQUE', 'PDC'].includes((paymentType || '').trim().toUpperCase());
export const isCheque = (paymentType) => (paymentType || '').trim().toUpperCase() === 'CHEQUE';

export const MAX = { chequeNo: 50, drawnBank: 255, refNo: 50, narration: 1000 };

const blank = (v) => !(v || '').toString().trim();

/**
 * Validation schema for section 4.
 * values: { customer, paymentType, debitAccount, setOffVoucher, voucherDate, chequeNo, chequeDate,
 *           drawnBank, amount, refNo, narration, conversionRate, additionalAccount, additionalAmount }
 * options: { mode: 'create' | 'edit', rows, financialYearRange: { from, to, label } | null, today }
 * Returns an object of { fieldKey: message }; empty means valid.
 */
export const validateReceipt = (values, { mode, rows = [], financialYearRange = null, today = new Date() }) => {
    const e = {};
    const setOff = isSetOff(values.paymentType);
    const create = mode === 'create';

    if (create && !values.customer) e.customer = 'Select Customer';
    if (blank(values.paymentType)) e.paymentType = 'Select Payment Type';

    if (!blank(values.paymentType)) {
        if (setOff) {
            if (create && !values.setOffVoucher) e.debitAccount = 'Select Receipt Voucher';
        } else if (!values.debitAccount) {
            e.debitAccount = 'Select Debit Account';
        }
    }

    if (!values.voucherDate) e.voucherDate = 'Select Voucher Date';

    if (isChequeOrPdc(values.paymentType)) {
        const chequeNo = (values.chequeNo || '').trim();
        if (!chequeNo || chequeNo === '0') e.chequeNo = 'Enter Cheque No.';
        if (!values.chequeDate) e.chequeDate = 'Enter Cheque Date.';
    }
    if (isCheque(values.paymentType) && values.chequeDate && !e.chequeDate) {
        if (values.voucherDate && moment(values.chequeDate).isAfter(values.voucherDate, 'day')) {
            e.chequeDate = 'Cheque date higher then Voucher date.';
        } else if (moment(values.chequeDate).isAfter(today, 'day')) {
            e.chequeDate = 'Cheque date should not be greater than todays date';
        }
    }

    if ((values.chequeNo || '').length > MAX.chequeNo) e.chequeNo = `Cheque No cannot exceed ${MAX.chequeNo} characters.`;
    if ((values.drawnBank || '').length > MAX.drawnBank) e.drawnBank = `Drawn Bank cannot exceed ${MAX.drawnBank} characters.`;
    if ((values.refNo || '').length > MAX.refNo) e.refNo = `Ref No cannot exceed ${MAX.refNo} characters.`;
    if ((values.narration || '').length > MAX.narration) e.narration = `Common Narration cannot exceed ${MAX.narration} characters.`;

    if (!create) {
        if (financialYearRange && values.voucherDate && !e.voucherDate) {
            const d = moment(values.voucherDate);
            if (d.isBefore(financialYearRange.from, 'day') || d.isAfter(financialYearRange.to, 'day')) {
                e.voucherDate = `Voucher date must stay within financial year ${financialYearRange.label}.`;
            }
        }
        return e;
    }

    const amount = num(values.amount);
    if (amount < 0) e.amount = 'Negative amount not allowed.';
    else if (amount <= 0) e.amount = 'Enter Amount.';

    if (!setOff && !(num(values.conversionRate) > 0)) e.conversionRate = 'Conversion Rate must be greater than 0.';

    const ticked = rows.filter((r) => r.selected);
    if (ticked.length === 0) {
        e.rows = 'No record is selected.';
    } else if (ticked.some((r) => !(num(r.amount) > 0) || round3(r.amount) > round3(r.balance))) {
        e.rows = 'Amount is greater than available amount';
    }

    const additional = num(values.additionalAmount);
    if (values.additionalAccount && additional === 0) e.additionalAmount = 'FX Amount difference required.';
    if (!values.additionalAccount && additional !== 0) e.additionalAccount = 'FX Amount difference account required.';

    if (!e.rows && !e.amount && summary(amount, rows, additional).unallocated !== 0) {
        e.allocation = 'Allocated amount does not match with amount entered.';
    }
    return e;
};
